// The plans endpoint is geolocated by IP, so the currency it returns is what we
// use to decide which local payment options to advertise.
// Only `symbol` is guaranteed on the currency object, so the ISO code is treated
// as optional and we fall back to the symbol when it is missing.
export const isIndianCurrency = (currency) => {
    if (!currency) return false;

    const code = (currency.code || currency.name || '').toString().trim().toUpperCase();
    if (code) return code === 'INR';

    return currency.symbol === '₹';
};
